<script setup lang="ts">
import type { CartItem } from "@/schemas/cart";

defineProps<{ cartItem: CartItem }>();
</script>

<template>
  <ul v-if="cartItem.details.length" class="text-sm font-medium leading-tight text-muted">
    <li v-for="(detail, i) in cartItem.details" :key="i">
      {{ detail }}
    </li>
  </ul>
</template>
